import React from "react";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import ContactForm from "@/components/ContactForm";
import { SITE } from "@/lib/site";

export default function Contact() {
  return (
    <>
      <SEO title="Contact" description="Contact Empire Serv. Phone, email, address, and office hours for our Asheboro, NC headquarters." path="/contact" />
      <PageHero
        eyebrow="Contact"
        title="Talk to a real person."
        subtitle="Send a message or reach us directly by phone or email — we respond within one business day."
        image="https://images.pexels.com/photos/36286291/pexels-photo-36286291.jpeg"
        height="h-[42vh]"
        testId="contact-hero"
      />

      <section className="es-section bg-white">
        <div className="es-container grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 space-y-4">
            <ContactBlock icon={Phone} label="Phone" value={SITE.phone} href={SITE.phoneHref} testId="contact-phone" />
            <ContactBlock icon={EnvelopeSimple} label="Email" value={SITE.email} href={`mailto:${SITE.email}`} testId="contact-email-link" />
            <ContactBlock icon={MapPin} label="Headquarters" value={`${SITE.address.line1}, ${SITE.address.city}, ${SITE.address.state} ${SITE.address.zip}`} testId="contact-address" />
            <ContactBlock icon={Clock} label="Office Hours" value={SITE.hours} testId="contact-hours" />

            <div className="border border-[var(--es-border)] rounded-sm overflow-hidden">
              <iframe
                title="Empire Serv Headquarters"
                src="https://www.google.com/maps?q=15+S+Fayetteville+St,+Asheboro,+NC+27203&output=embed"
                width="100%"
                height="280"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="border-0"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}

function ContactBlock({ icon: Icon, label, value, href, testId }) {
  const inner = (
    <div data-testid={testId} className="bg-white border border-[var(--es-border)] p-5 rounded-sm flex items-start gap-4">
      <div className="w-11 h-11 bg-[var(--es-navy)] text-white flex items-center justify-center rounded-sm flex-shrink-0">
        <Icon size={20} weight="fill" />
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[var(--es-text-muted)]">{label}</div>
        <div className="font-semibold text-[var(--es-navy)] mt-1">{value}</div>
      </div>
    </div>
  );
  return href ? <a href={href} className="block hover:opacity-90 transition-opacity">{inner}</a> : inner;
}
